export default "__VITE_PUBLIC_ASSET__4021012f__"